const Auth = {
  login: () => 'login',
  logout: () => 'logout',
}
export default Auth
